export class FSAContribution {
    deductionAmount: number;

    constructor() {
        this.deductionAmount = 0;
    }
}

export class FSAContributionPayload {
    annualContribution: number;

    constructor() {
        this.annualContribution = 0;
    }
}